import { DadosAluno } from '@/models/sie-pedidos/dadosAluno';
import {Endereco} from "@/models/sie-pedidos/endereco";
import {DadosSolicitacao} from "@/models/sie-pedidos/dadosSolicitacao";


const initialStateEndereco: Endereco = {
  semNumero: false,
  numero: null,
  bairro: null,
  complemento: null,
  cep: null,
  municipio: null,
  logradouro: null
}

const initialStateAluno: DadosAluno = {
  id: null,
  cpf: null,
  nome: null,
  identidade: null,
  matricula: null,
  nomeSocial: null,
  dataNascimento: null,
  fone: null,
  email: null,
  sexoId: null,
  possuiMae: true,
  nomeMae: null,
  enderecoPayload: initialStateEndereco
}

const formState: DadosSolicitacao = {
  aluno: initialStateAluno,
  cpf: null,
  tipoSolicitacaoId: null,
  lgpd: null,
  recaptcha: false,
  alunoId: null,
  documentoRg: null,
  documentoCpf: null,
  documentoFoto: null,
  documentoResponsavel: null,
  documentoComprovanteMatricula: null,
  documentoComprovanteResidencia: null,
  documentoFichaCadastral: null
}

export default formState
